{
    "runtime": {
        "preloadSyncTimeoutMs": 180000,
        "matchReadySyncTimeoutMs": 240000,
        "navCollClampsToNavMesh": false
    }
}
